import React from "react"
import { useTranslation } from "react-i18next"

import { Checkbox } from "components"
import classes from "./FailedPrintTableRowHeader.module.scss"

const FailedPrintTableRowHeader = props => {
  const {
    thisPrinterFailedPrints,
    selectedFailedPrints,
    setSelectedFailedPrints
  } = props

  const [t] = useTranslation()


  const handleSelectAll = (checked) => {
    const result = {}

    checked &&
      thisPrinterFailedPrints.forEach(thisPrinterFailedPrint => {
        result[thisPrinterFailedPrint.printRequestId] = thisPrinterFailedPrint
      })

    setSelectedFailedPrints(result)
  }

  const showCheckbox =
    thisPrinterFailedPrints.length !== 0

  const selectAll =
    thisPrinterFailedPrints.length ===
    Object.keys(selectedFailedPrints).length

  return (
    <thead className={classes["header"]}>
      <tr>
        <th className={classes["header-item"]}>
          {
            showCheckbox &&
            <Checkbox
              onChange={handleSelectAll}
              checked={selectAll}
            />
          }
        </th>
        <th className={classes["header-item"]}>
          {t("نوع_پرینت")}
        </th>
        <th className={classes["header-item"]}>
          {t("تاریخ_ایجاد")}
        </th>
      </tr>
    </thead>
  )
}

export default FailedPrintTableRowHeader